import React from "react";
import { Route } from "react-router-dom";
import MainLayout from "../../components/MainLayout/MainLayout";
import CheckoutLayout from "../../components/CheckoutLayout/CheckoutLayout";
import { AuthenticationGuard } from "@/components/AuthenticationGuard/AuthenticationGuard";
import EventDirectory from "@/modules/eventRegistration/features/EventDirectory/components/EventDirectory/EventDirectory";
import EventDetails from "@/modules/eventRegistration/features/EventDirectory/components/EventDetails/EventDetails";
import MyRegistrationsPage from "@/modules/eventRegistration/features/MyRegistrations/components/MyRegistrationsPage/MyRegistrationsPage";
import EventRegistrationPage from "@/modules/eventRegistration/features/EventRegistration/components/EventRegistrationPage/EventRegistrationPage";
import Confirmation from "@/modules/eventRegistration/features/EventRegistration/components/Confirmation/Confirmation";

// Browsing pages — full app shell with sidebar/nav
const EventRegistrationMainLayout = () => (
  <MainLayout section="event-registration" />
);

// Checkout pages — stripped-down focused layout
const EventRegistrationCheckoutLayout = () => <CheckoutLayout />;

const EventRegistrationRoutes = (
  <>
    {/* Browsing — full app shell */}
    <Route
      element={<AuthenticationGuard component={EventRegistrationMainLayout} />}
      path="/event-registration"
    >
      <Route element={<EventDirectory />} path="events" />
      <Route element={<EventDetails />} path="events/:uuid" />
      <Route element={<MyRegistrationsPage />} path="my-registrations" />
    </Route>

    {/* Checkout + confirmation — focused layout */}
    <Route
      element={
        <AuthenticationGuard component={EventRegistrationCheckoutLayout} />
      }
      path="/event-registration"
    >
      <Route
        element={<EventRegistrationPage />}
        path="events/:eventSessionUuid/register"
      />
      <Route
        element={<Confirmation />}
        path="events/:eventCheckoutSessionUuid/confirmation"
      />
    </Route>
  </>
);

export default EventRegistrationRoutes;
